export const CONTRACT_PREPARATION_SUPERSEDED_CODE = `CONTRACT_PREPARATION_SUPERSEDED`

export const CONTRACT_PREPARATION_SUPERSEDED_MESSAGE = `Contract preparation was superseded by a proposal change. Reload readiness and send again.`

export const isContractPreparationSupersededError = (
  error: unknown,
): boolean => {
  if (error == null || typeof error !== `object` || !(`response` in error)) {
    return false
  }

  const { response } = error
  if (
    response == null ||
    typeof response !== `object` ||
    !(`data` in response)
  ) {
    return false
  }

  const { data } = response
  if (data == null || typeof data !== `object` || !(`error` in data)) {
    return false
  }

  return data.error === CONTRACT_PREPARATION_SUPERSEDED_CODE
}
